export enum PropertyRecordCalculationStatus {
    NONE,
    OK,
    EMPTY_RESPONSE,
    NO_BUILDINGS,
    TIMEOUT,
    ERROR,
    NOT_SAVED,
    WITH_NOTIFICATIONS,
    INCORRECT_PARAMETERS
}

export enum CalculationErrorStatuses {
    'Not calculated' = PropertyRecordCalculationStatus.NONE, // 0
    'No project' = PropertyRecordCalculationStatus.EMPTY_RESPONSE, // 2
    'No buildings' = PropertyRecordCalculationStatus.NO_BUILDINGS, // 3
    'Request timeout' = PropertyRecordCalculationStatus.TIMEOUT, // 4
    'Exception in calculations' = PropertyRecordCalculationStatus.ERROR, // 5
    'Cannot be saved' = PropertyRecordCalculationStatus.NOT_SAVED, // 6
    'Incorrect parameters' = PropertyRecordCalculationStatus.INCORRECT_PARAMETERS // 8
}

export namespace CalculationErrorStatuses {
    export function keys(): Array<string> {
        let keys = Object.keys(CalculationErrorStatuses);
        return keys.slice(keys.length / 2, keys.length - 1);
    }
}

export function getPrettyPropertyRecordCalculationStatus(propertyRecordCalculationStatus: number): string {
    return [
        '',
        'Properly calculated',
        'No project',
        'No buildings',
        'Request timeout',
        'Exception in calculations',
        'Cannot be saved',
        'Properties with notifications',
        'Incorrect parameters'
    ][propertyRecordCalculationStatus];
}
